<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> SIM Data Details</span>
    </div>
  </div>

  <div class="component-container">
    <!-- List Section -->
    <form [formGroup]="simDataDetailsForm" novalidate>
      <div class="component-header">
        <h6 class="component-title">SIM Data Details List</h6>
        <div class="component-actions">
          <button
            class="primary-button"
            type="button"
            (click)="DownloadOutputReport()"
          >
            Download Report<mat-icon class="btn-icon" type="button"
              >download</mat-icon
            >
          </button>
          <app-common-search
            [initialSearchValue]="
              simDataDetailsForm?.get('batchListSearch')?.value
            "
            matTooltip="UIN NO. | VIN NO. | IMEI NO. | Primary Mob. NO. | Secondary Mob. NO."
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>UIN NO.</th>
              <th>VIN NO.</th>
              <th>IMEI NO.</th>
              <th>Primary Operator</th>
              <th>Primary Mob. NO.</th>
              <th>Secondary Operator</th>
              <th>Secondary Mob. NO.</th>
              <th>SIM Status</th>
              <th>Activation Status</th>
              <th>Activation Start Date</th>
              <th>Activation Expiry Date</th>
              <th>Vahan Status</th>
            </tr>
          </thead>
          @if (listOfBatch.length > 0) {
            <tbody>
              @for (
                simDataValue of listOfBatch
                  | paginate
                    : {
                        id: 'batchPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track simDataValue
              ) {
                <tr>
                  <td>{{ simDataValue.uin ? simDataValue.uin : '--' }}</td>
                  <td>{{ simDataValue.vinNo ? simDataValue.vinNo : '--' }}</td>
                  <td>{{ simDataValue.imei ? simDataValue.imei : '--' }}</td>
                  <td>
                    {{
                      simDataValue.primaryOperator
                        ? simDataValue.primaryOperator
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      simDataValue.primaryMobileNumber
                        ? simDataValue.primaryMobileNumber
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      simDataValue.secondaryOperator
                        ? simDataValue.secondaryOperator
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      simDataValue.secondaryMobileNumber
                        ? simDataValue.secondaryMobileNumber
                        : '--'
                    }}
                  </td>
                  <td>
                    {{ simDataValue.simStatus ? simDataValue.simStatus : '--' }}
                  </td>
                  <td>
                    {{
                      simDataValue.activationStatus
                        ? simDataValue.activationStatus
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      simDataValue.activationStartDate
                        ? (simDataValue.activationStartDate
                          | date: 'dd-MMM-yyyy')
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      simDataValue.activationExpiryDate
                        ? (simDataValue.activationExpiryDate
                          | date: 'dd-MMM-yyyy')
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      simDataValue.vahanStatus ? simDataValue.vahanStatus : '--'
                    }}
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (listOfBatch.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (listOfBatch.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            [totalPages]="totalLength"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </form>
  </div>
</div>
